import Sort from '@/app/_components/ui/icons/Sort.svg';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function SortFilter({ sort, handlerSort }) {
  const isMobile = useIsMobile();

  const sortList = [
    {
      name: 'جدیدترین',
      value: '1',
    },
    {
      name: 'مفیدترین',
      value: '2',
    },
    {
      name: 'عکس دار',
      value: '3',
    },
    {
      name: 'فقط متن',
      value: '4',
    },
  ];

  return (
    <div>
      {!isMobile ? (
        <div className="sort-comments flex ">
          <Sort />
          <span className="text-gray-100 text-sm pr-2">مرتب سازی بر اساس:</span>
          <ul className="flex">
            {sortList.map((sortItem, index) => (
              <li
                key={index}
                className={
                  'px-2 text-sm  cursor-pointer' +
                  (sortItem.value
                    ? 'text-button-color-primary'
                    : 'text-gray-200')
                }
                onClick={() => handlerSort(sortItem.value)}
              >
                <span
                  className={` cursor-pointer ${
                    sort == sortItem.value ? 'text-ocean-blue' : ''
                  }`}
                >
                  {sortItem.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="sort-products flex flex-wrap -mx-2 items-center pb-2">
          <div className=" px-2 lg:w-1/2 ">
            <div className=" flex items-center  rounded-md md:p-3">
              <Sort />
              <select
                className="py-0 pr-2 min-w-[90px] border-none bg-transparent focus:ring-0 text-xs w-full"
                onChange={(event) => handlerSort(event.target.value)}
              >
                {sortList.map((sortItem, index) => (
                  <option key={index} value={sortItem.value}>
                    {sortItem.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
